module.exports = __webpack_public_path__ + "media/11 World Environment Day.e5f8efd1.mp3";